// Shared app constants (pure data) extracted from App.jsx.
import { CATEGORY_LABELS, ICON_CATEGORIES } from "../BuzerIcons";

// Mood vocabulary (id ↔ icon ↔ label) + id→icon helper.
export const MOODS = [
  { id: "skvele", icon: "great", label: "Skvelý deň" },
  { id: "fajn", icon: "good", label: "V pohode" },
  { id: "neutral", icon: "neutral", label: "Neutrálne" },
  { id: "vykyvy", icon: "wavy", label: "Výkyvy" },
  { id: "tazko", icon: "hard", label: "Ťažký deň" },
];
export const moodIconName = (id) => MOODS.find((m) => m.id === id)?.icon || "neutral";

// Reakcie na správy v chate — zrkadlí app.py MSG_REACTIONS (poradie = poradie vo výbere).
// Ikony sú z vlastnej sady (BuzerIcons), nie emoji, nech sedia so zvyškom appky a s témami.
export const MSG_REACTIONS = [
  { kind: "heart", icon: "heart", label: "Srdce" },
  { kind: "laugh", icon: "laugh", label: "Smiech" },
  { kind: "wow", icon: "wow", label: "Prekvapenie" },
  { kind: "cry", icon: "cry", label: "Plač" },
];

// v9 — the icon vocabulary the AI may suggest from: content icons only (no UI chrome, no mood faces,
// which aren't in CATEGORY_LABELS). Sent to the habit-suggest endpoint and validated server-side.
export const SUGGEST_ICONS = Object.keys(CATEGORY_LABELS)
  .filter((c) => c !== "ui")
  .flatMap((c) => ICON_CATEGORIES[c] || []);

// Opakovanie pripomienok (tasks.repeat). Jediný zdroj pravdy pre labely v UI.
export const REPEAT_LABEL = { none: "Jednorázovo", daily: "Každý deň", weekly: "Každý týždeň", monthly: "Každý mesiac", yearly: "Každý rok", custom: "Vlastné dátumy" };
export const REPEAT_SHORT = { daily: "denne", weekly: "týždenne", monthly: "mesačne", yearly: "ročne", custom: "vlastné dátumy" };

// v32 — životné kategórie návykov/výziev/súťaží (pevná sada, kľúče zrkadlí backend HABIT_CATS).
// icon = názov zo sady BuzerIcons; label = krátky názov do pilulky/dlaždice, full = celý názov.
export const LIFE_CATS = [
  { key: "zdravie", label: "Zdravie", full: "Zdravie", icon: "heart" },
  { key: "mysel", label: "Myseľ", full: "Myseľ", icon: "brain" },
  { key: "dusa", label: "Duša", full: "Psychika / Duša", icon: "meditation" },
  { key: "vztahy", label: "Vzťahy", full: "Vzťahy", icon: "people" },
  { key: "praca", label: "Práca", full: "Práca", icon: "briefcase" },
  { key: "financie", label: "Financie", full: "Financie", icon: "chart" },
  { key: "domov", label: "Domov", full: "Domov", icon: "house" },
  { key: "zabava", label: "Zábava", full: "Voľný čas a zábava", icon: "palette" },
];
export const LIFE_CAT = Object.fromEntries(LIFE_CATS.map((c) => [c.key, c]));

// v33b — „N× za obdobie" (recur_mode='period'/'weekly_count'). Kľúče zrkadlia backend
// db.RECUR_PERIODS + recur.ts RecurPeriod. label = do selectu; unit = do štítku „N× <unit>".
export const RECUR_PERIODS = [
  { key: "week", label: "týždeň", unit: "týždeň" },
  { key: "month", label: "mesiac", unit: "mesiac" },
  { key: "half", label: "pol rok", unit: "pol rok" },
  { key: "year", label: "rok", unit: "rok" },
];
export const RECUR_PERIOD_UNIT = Object.fromEntries(RECUR_PERIODS.map((p) => [p.key, p.unit]));
// merateľný návyk „N× za obdobie": cieľ platí na celé obdobie, nie na deň — toto je jeho
// pomenovanie v zápisovom sheete aj v dlaždici detailu („z 10 000 krokov · tento týždeň").
export const METRIC_PERIOD_SCOPE = { week: "tento týždeň", month: "tento mesiac", half: "tento polrok", year: "tento rok" };
// krátka verzia do dlaždice v detaile návyku (na mieste, kde denný návyk hlási „DNES")
export const METRIC_PERIOD_SHORT = { week: "TÝŽDEŇ", month: "MESIAC", half: "POLROK", year: "ROK" };
// koľko dní dozadu sa dá dopísať hodnota — zrkadlí app.py METRIC_BACKFILL_DAYS
export const METRIC_BACKFILL_DAYS = 30;
// DENNÍK DŇA (feature-spec-dennik.md §2.2) — pevná sada štítkov zápisu; kľúče zrkadlia journal.TAGS.
// Vlastné štítky zámerne nie sú (rozhodnutie majiteľky 2026-09-07). Ikony zo sady BuzerIcons.
export const JOURNAL_TAGS = [
  { key: "pohyb", label: "Pohyb", icon: "footprints" },
  { key: "ludia", label: "Ľudia", icon: "people" },
  { key: "praca", label: "Práca", icon: "briefcase" },
  { key: "oddych", label: "Oddych", icon: "leaf" },
  { key: "jedlo", label: "Jedlo", icon: "apple" },
  { key: "spanok", label: "Spánok", icon: "bed" },
];
export const JOURNAL_TAG = Object.fromEntries(JOURNAL_TAGS.map((t) => [t.key, t]));
// koľko dní dozadu sa dá dopísať zápis — zrkadlí journal.BACKFILL_DAYS
export const JOURNAL_BACKFILL_DAYS = 30;
// ako ďaleko dopredu sa dá naplánovať začiatok návyku/výzvy — zrkadlí app.py START_MAX_AHEAD_DAYS
export const START_MAX_AHEAD_DAYS = 365;
// UI strop stepperov za obdobie (backend povoľuje viac; tu držíme použiteľný rozsah).
export const RECUR_PERIOD_MAX = { week: 6, month: 15, half: 26, year: 52 };

// v14 — duration presets (days): týždeň / mesiac / pol roka / rok; anything else = "Vlastné"
export const DUR_PRESETS = [7, 30, 182, 365];
export const DUR_OPTIONS = [[7, "Týždeň"], [30, "Mesiac"], [182, "Pol roka"], [365, "Rok"]];

// v15 §7 — coarse-pointer (touch) check; don't force the keyboard open with autoFocus on phones
export const IS_TOUCH = typeof window !== "undefined" && !!window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
// v26.2 §2 — Android (Mali/Chrome) mishandles backdrop-filter over scrolling content → drop blur.
export const IS_ANDROID = typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);

// v16/v17 — app colour swatches (base --ember of each data-theme). Shared by both theme pickers.
// v17 — full palette incl. black as a primary accent (not dark mode).
export const APP_THEME_SWATCHES = [
  ["green", "#6E7E5E"], ["emerald", "#2E9E5B"], ["teal", "#1F8A7D"], ["turquoise", "#0FA39B"], ["slate", "#45688F"], ["blue", "#3E73B0"],
  ["purple", "#7E5E9E"], ["violet", "#7C3AED"], ["gold", "#C49A3A"], ["amber", "#C98A1E"], ["terracotta", "#C2552F"], ["red", "#DB3B2B"],
  ["rose", "#C2486B"], ["pink", "#D6418A"], ["black", "#1C1A17"],
  // v20 §7 — extra vivid themes
  ["cobalt", "#0A4DFF"], ["aqua", "#00D2C4"], ["jade", "#00B36B"],
  ["tangerine", "#FF6D00"], ["fuchsia", "#FF007F"], ["ultraviolet", "#7209B7"],  // v25 — cyber (žltá) stiahnutá z ponuky
];
export const SWATCH = Object.fromEntries(APP_THEME_SWATCHES);

export const QUOTES = [
  "Žiadne výhovorky. Buď výsledky, alebo dôvody, prečo ich nemáš.",
  "Nečakaj na náladu. Disciplína nepozná „dnes sa mi nechce“.",
  "Bolesť disciplíny trvá chvíľu. Bolesť ľútosti zostáva. Vyber si.",
  "Slabšie ja chce prestať. Silnejšie ja koná. Buď to silnejšie.",
  "Sprav to, aj keď sa ti nechce — hlavne vtedy.",
  "Tvoje budúce ja sleduje, čo robíš teraz. Nesklam ho.",
  "Konzistencia bije talent. Ukáž sa každý deň, bez kompromisov.",
  "Streak sa neláme „len dnes“. Žiadne „len dnes“ neexistuje.",
];

// Chat message reactions: emoji ↔ BuzerIcon name.
export const REACTIONS = [["👍", "thumbsup"], ["❤️", "heart"], ["🔥", "flame"], ["💪", "dumbbell"], ["😂", "smile"], ["🎉", "star2"]];

// v24 — celebration effects (shop-unlockable). EffectBurst renders these; the shop lists them.
export const EFFECTS = [
  { code: "confetti", label: "Konfety" },
  { code: "hearts", label: "Srdiečka", icon: "heart", color: "#E26D8A" },
  { code: "clover", label: "Štvorlístky", icon: "clover", color: "#4FAE5A" },
  { code: "star", label: "Hviezdičky", icon: "star2", color: "#E5B53B" },
];

// v24 — shop item icons (BuzerIcon names; frames = same icon, different colour)
export const SHOP_ITEM_ICON = {
  freeze: { name: "lifebuoy" },
  frame_gold: { name: "frame", color: "#d4a017" },
  frame_neon: { name: "frame", color: "#8b5cf6" },
  flair_crown: { name: "crown" },
  flair_halo: { name: "sparkles", color: "#d4a017" },
  theme_dark: { name: "moon" },
  // v2.1 — milestone flairs (odmeny za tiery levelov, nekúpiteľné)
  flair_shield: { name: "shield", color: "#96591f" },
  flair_star: { name: "star2", color: "#d4a017" },
  flair_royal: { name: "crown", color: "#d4a017" },
  flair_bolt: { name: "bolt", color: "#8b5cf6" },
};

// Zdieľaný kalendár s priateľom — row colouring by owner (zdieľané / moje / priateľa).
export const OWNER_STYLE = {
  shared: { bg: "#E3EFEA", color: "#3E7A63", label: "zdieľané" },
  me: { bg: "#FBE9DA", color: "#C26B3E", label: "moje" },
  friend: { bg: "#EFE4F2", color: "#7A5E86", label: "priateľa" },
};

// Šťuchnúť (buzerák) — canned poke lines sent to a friend.
export const BUZERAK_LINES = [
  "nezabudni dnes na svoje návyky! 💪", "kde máš dnešnú sériu? 🔥",
  "voda sa sama nevypije 💧", "šup-šup, ešte to dnes stihneš! ⏰", "sledujem ťa 👀",
];

// v31 — Ktorú HLAVNÚ verziu má „Čo je nové" ohlásiť bannerom na Dnes.
//
// Predtým sa banner viazal priamo na číslo verzie, takže vyskočil VŠETKÝM pri každom
// zdvihnutí hlavnej verzie — aj keď v tej dávke nebolo čo ohlasovať, alebo keď sa
// changelog ešte nestihol dopísať (presne to sa stalo pri v31: banner vyskočil s obsahom
// pre v30). Odteraz je to VÝSLOVNÉ rozhodnutie: záznam v „Čo je nové" pribudne vždy, ale
// banner sa ukáže len tej verzii, ktorá je tu vypísaná.
//
// `null` = žiadny banner; novinky si človek nájde v menu → „Čo je nové".
// Ohlásiť dávku = sem napísať hlavné číslo verzie ako reťazec, napr. "32".
export const NEWS_BANNER_MAJOR = "33";
